__turbopack_context__.v({
  "search": "helpCenterSearchBlock-module-scss-module__w13hdG__search",
  "searchBox": "helpCenterSearchBlock-module-scss-module__w13hdG__searchBox",
  "title": "helpCenterSearchBlock-module-scss-module__w13hdG__title",
});
